import {
  Dialog,
  DialogMaxWidth,
  DialogVariant,
  Grid,
  Text,
  TextHighlight,
  TextSize
} from '@focaldata/cin-ui-components'

interface Props {
  open: boolean
  /** Market display label, shown in the title (e.g. "United Kingdom"). */
  marketName?: string
  /** True while the removal mutation is in flight. */
  busy: boolean
  onConfirm: () => void
  onClose: () => void
}

/**
 * Confirmation shown before a draft market is removed from a multi-market
 * project. Shared by the project page's markets table ("Remove") and the
 * per-market "Market settings" drawer ("Remove this market"), so both routes to
 * removal are gated behind the same explicit confirm. Removal deletes the
 * market's audience, language and target settings, so it cannot be done in one
 * click.
 */
const RemoveMarketDialog = ({
  open,
  marketName,
  busy,
  onConfirm,
  onClose
}: Props) => (
  <Dialog
    open={open}
    // Don't let a click-outside dismiss mid-removal.
    onClose={busy ? () => undefined : onClose}
    title={marketName ? `Remove ${marketName}?` : 'Remove this market?'}
    variant={DialogVariant.DoubleButton}
    maxWidth={DialogMaxWidth.Sm}
    primaryButtonText={busy ? 'Removing…' : 'Remove market'}
    primaryButtonClick={onConfirm}
    primaryButtonDisabled={busy}
    primaryButtonLoading={busy}
    secondaryButtonText="Cancel"
    secondaryButtonClick={onClose}
    secondaryButtonDisabled={busy}
  >
    <Grid container direction="column" spacing={1} style={{ padding: 16 }}>
      <Grid item>
        <Text size={TextSize.ml} highlight={TextHighlight.Background}>
          This market and its audience, language and target settings will be
          removed from the project. Questionnaire translations are kept —
          re-adding this country, or any market in the same language, reapplies
          them.
        </Text>
      </Grid>
    </Grid>
  </Dialog>
)

export default RemoveMarketDialog
